import {
	ASK_LOCATION_PERMISSION_FAILURE,
	ASK_LOCATION_PERMISSION_REQUEST,
	ASK_LOCATION_PERMISSION_SUCCESS,
	LOAD_LOCATION_PERMISSION_STATUS_FAILURE,
	LOAD_LOCATION_PERMISSION_STATUS_REQUEST,
	LOAD_LOCATION_PERMISSION_STATUS_SUCCESS,
} from 'new-constants/permission.constants';
import {LOCATION_PERMISSION_CONFIRMATION_POPUP} from 'new-components/popups/confirmation/Confirmation';

export const askLocationPermissionRequest = () => ({
	type: ASK_LOCATION_PERMISSION_REQUEST,
});

export const askLocationPermissionSuccess = status => ({
	type: ASK_LOCATION_PERMISSION_SUCCESS,
	hidePopups: [LOCATION_PERMISSION_CONFIRMATION_POPUP],
	status,
});

export const askLocationPermissionFailure = () => ({
	type: ASK_LOCATION_PERMISSION_FAILURE,
	hidePopups: [LOCATION_PERMISSION_CONFIRMATION_POPUP],
});

export const loadLocationPermissionStatusRequest = () => ({
	type: LOAD_LOCATION_PERMISSION_STATUS_REQUEST,
});

export const loadLocationPermissionStatusSuccess = status => ({
	type: LOAD_LOCATION_PERMISSION_STATUS_SUCCESS,
	status,
});

export const loadLocationPermissionStatusFailure = () => ({
	type: LOAD_LOCATION_PERMISSION_STATUS_FAILURE,
});
